export * from 'server/models/HomePage';


// WEBPACK FOOTER //
// ./data/models/HomePage.ts